import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { runbookConnectorActions } from "../../actions/runbookConnector.actions";
import { useLocation } from "react-router-dom";
import Utils from "../../utils";

function RunbookConnectorDropdown({ user, onChange, value }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const [runbookConnectors, setRunbookConnectors] = useState([]);
  const runbookConnectorReducer = useSelector(
    (state) => state.runbookConnector
  );

  useEffect(() => {
    const runbookId = Utils.getQueryStringParams(location)["runbookId"];

    let queryParams = {
      clientId: user.clientId,
      clientGuid: user.clientGuid,
      runbookId,
    };

    dispatch(runbookConnectorActions.get(queryParams));

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (runbookConnectorReducer.successGet) {
      setRunbookConnectors(runbookConnectorReducer.paginatedResult.data);
    }

    // eslint-disable-next-line
  }, [runbookConnectorReducer.successGet]);

  return (
    <>
      {runbookConnectors && (
        <Form.Select onChange={(e) => onChange(e.target.value)} value={value}>
          <option value={""}>-</option>
          {runbookConnectors.map((rs, i) => (
            <option value={rs.connectorId} key={i}>
              {rs.connectorNumber} - {rs.system} - {rs.loginEndpoint}
            </option>
          ))}
        </Form.Select>
      )}
    </>
  );
}

export default RunbookConnectorDropdown;
